import gql from 'graphql-tag';

import { useMutation } from '@apollo/client';
import { REGION_FIELDS } from '../../fragments/fence/region';
import { UpdateRegion, UpdateRegionVariables } from '../../athena/types/UpdateRegion';

export const UPDATE_REGION = gql`
  mutation UpdateRegion($identifier: String, $tagIdentifiers: [String!], $postalCodes: [String!]) {
    fence {
      updateRegion(
        input: {
          region: {
            identifier: $identifier
            tagIdentifiers: $tagIdentifiers
            details: { postalCodes: $postalCodes }
          }
        }
      ) {
        region {
          ...RegionFields
        }
      }
    }
  }
  ${REGION_FIELDS}
`;

export const useUpdateRegion = () => {
  return useMutation<UpdateRegion, UpdateRegionVariables>(UPDATE_REGION);
};
